import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HomeCategories() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            探索分类
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            六大摄影主题分类，按你的兴趣选择学习方向
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, index) => {
            const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
              accent: { bg: 'hover:bg-accent-50', text: 'text-accent-700', iconBg: 'bg-accent-100' },
              primary: { bg: 'hover:bg-primary-50', text: 'text-primary-700', iconBg: 'bg-primary-100' },
              secondary: { bg: 'hover:bg-secondary-50', text: 'text-secondary-700', iconBg: 'bg-secondary-100' },
            };
            const colors = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70 transition-all duration-300 cursor-pointer ${colors.bg}`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${colors.iconBg} flex-shrink-0`}>
                  <i className={`${cat.icon} text-xl ${colors.text}`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-base font-semibold text-foreground-950 font-heading mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-400">
                    {cat.articleCount} 篇文章
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}